// extracted by mini-css-extract-plugin
export default {"container":"Contacts_container__AYpIW","mapWrapper":"Contacts_mapWrapper__lfK5O","address":"Contacts_address__njkFl","map":"Contacts_map__S0mHw"};